export enum PrintStatus {
  NONE = "none",
  PRINTING = "printing",
  ERROR = "error",
  OFFLINE = "offline",
}
